import { useState, useEffect } from "react";
import axios from "axios"
import { IoMdArrowRoundBack } from "react-icons/io";


import Usuarios from "./components/Usuarios.js"
import NovaPagina from "./components/NovaPagina.js";
import Grid from "./components/Grid.js";
import NovoModulo from "./components/NovoModulo.js";

import GlobalStyle from "../../../styles/global.js";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fundo from "../../../styles/fundo.svg";

const DivLayout = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
`;

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;
`;

const Div = styled.div`
background-color:  #fff;
`;

const Title = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 5.5rem;
  background-image: url(${fundo});
`;

const Title2 = styled.h2`
  width: 100%;
  color: #fff;
  font-size: 28px;
  display: flex;
  justify-content: space-around; 
  align-items: center;

  img{
    height: 50px;
    padding-top: 1.5%;
  }  
`;



const Filtro = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;


`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: start; 
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 80vh; 
  overflow-y: auto; 
`;

const ButtonClose = styled.button`
  position: fixed;
  cursor: pointer;
  border: none;
  background-color: #fff;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.5);
  }
`;



const ButtonSide1 = styled.button`
  
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #fff;
  font-size: 18px;

  &.toggle-btn {
    position: absolute;
    top: 2;
    left: 0;
    padding-left: 1vw;
  }

  &.button-exit{
    position: absolute;
    top: 2;
    right: 0;
    padding-right: 1vw;
  }

`;




function Modulos() {
  //-------------------------------------------------------------------//
  const id = localStorage.getItem('id');
  const token = localStorage.getItem('token');

  //-------------------------------------------------------------------//

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;
  const urlGestao = `${urlFront}gestao/`;

  //-----------------------------------------RECEBE OS MODULOS CADASTRADOS--------------------------//


  const [modulos, setModulos] = useState([]);
  const fetchModulos = async () => {
    try {
      const res = await axios.get(`${urlApi}gestao/modulos`, { headers: { Authorization: `Bearer ${token}` } });
      setModulos(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de modulo:', error);
    }
  };

  useEffect(() => {
    fetchModulos();
  }, [token]);


  //-------------------------------RECEBE OS PAGINAS CADASTRADAS------------------------------------//



  const [paginas, setPaginas] = useState([]);

  const fetchPagina = async () => {
    try {
      const res = await axios.get(`${urlApi}gestao/paginas`, { headers: { Authorization: `Bearer ${token}` } });
      setPaginas(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de pagina:', error);
    }
  };

  useEffect(() => {
    fetchPagina();
  }, [token]);


  //---------------------------------------STATE PARA ALTERAR A PAGINA---------------------------------------------------//

  const [onEdit, setOnEdit] = useState("");

  //---------------------------------------MODAL NOVO MODULO---------------------------------------------------//

  const [isModalOpenNovoModulo, setIsModalOpenNovoModulo] = useState(false);
  const modalNovoModulo = () => {
    setIsModalOpenNovoModulo(!isModalOpenNovoModulo);
  };


  //---------------------------------------MODAL NOVA PAGINA---------------------------------------------------//

  const [isModalOpenNovaPagina, setIsModalOpenNovaPagina] = useState(false);
  const modalNovaPagina = () => {
    setIsModalOpenNovaPagina(!isModalOpenNovaPagina);
  };

  //---------------------------------------MODAL USUÀRIOS BI---------------------------------------------------//

  const [isModalOpenUsuario, setIsModalOpenUsuario] = useState(false);
  const [usuarios, setUsuarios] = useState([]);

  // Alterna a abertura do modal
  const modalUsuarios = () => {
    setIsModalOpenUsuario(prev => !prev);

  };

  // Busca os usuários vinculados ao módulo/página selecionado
  const getUsuariosBI = async () => {

    // Protege contra chamadas inválidas
    if (!onEdit?.ID_MODULO || !onEdit?.ID_PAGINA) return;

    try {
      const response = await axios.post(`${urlApi}gestao/usuarios-bi`, {
        id_modulo: onEdit.ID_MODULO,
        id_pagina: onEdit.ID_PAGINA,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsuarios(response.data || []); // Garante que seja array
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
      setUsuarios([]); // limpa para evitar valores antigos
    }
  };


  useEffect(() => {
    if (isModalOpenUsuario && onEdit?.ID_MODULO && onEdit?.ID_PAGINA) {
      getUsuariosBI();
    }
  }, [isModalOpenUsuario, onEdit]);

  //---------------------------------------VOLTAR A PAGINA INICIAL---------------------------------------------------//

  const handleVoltar = () => {
    window.location.href = urlGestao;
  };






  //---------------------------------------VERIFICA O TOKEN---------------------------------------------------//


  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  useEffect(() => {
    const getToken = async () => {
      try {
        const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
        setToken(res.data);
      } catch (error) {
        if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
          window.location.href = `${urlFront}login`;
        } else {
          console.error("Erro ao obter token:", error);
        }
      }
    };



    getToken();

  }, [])


  //---------------------------------------VERIFICA SE O USUÀRIO PODE ACESSAR ESSA PAGINA---------------------------------------------------//
  useEffect(() => {
    const fetchAcessos = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const acessos = res.data;

        // Verifica se o usuário tem acesso ao módulo 0 com tipo A
        const possuiAcessoAoModulo0 = acessos.some(
          (acesso) => acesso.COD_MODULO === 1 && acesso.TIPO_ACESSO === "A"
        );

        if (!possuiAcessoAoModulo0) {
          // Redireciona se não tiver o acesso necessário
          window.location.href = '/login';
        }

      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
        window.location.href = '/login'; // Redireciona também em caso de erro (opcional)
      }
    };

    if (token && id) {
      fetchAcessos();
    }
  }, [token, id]);


  return (


    <div >
      <DivLayout>
        <Title>
          <div>
            <ButtonSide1 className="toggle-btn" onClick={handleVoltar}>
              <IoMdArrowRoundBack size={28} className="gap" />
            </ButtonSide1>
          </div>

          <Title2>
            <div>
              <h2>Cadastro de Links</h2>
            </div>




          </Title2>

        </Title>
      </DivLayout>
      <Div>
        {isModalOpenNovoModulo && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <ButtonClose onClick={() => {
                  modalNovoModulo();

                }}>
                  {isModalOpenNovoModulo ? <IoClose color={"red"} size={25} /> : <IoClose color={"red"} size={25} />}
                </ButtonClose>
              </ButtonContainer>
              <NovoModulo urlApi={urlApi} modulos={modulos} fetchModulos={fetchModulos} />
            </ModalContent>
          </ModalContainer>
        )}
        {isModalOpenNovaPagina && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <ButtonClose onClick={() => {
                  modalNovaPagina();

                }}>
                  {isModalOpenNovaPagina ? <IoClose color={"red"} size={25} /> : <IoClose color={"red"} size={25} />}
                </ButtonClose>
              </ButtonContainer>
              <NovaPagina urlApi={urlApi} fetchModulos={fetchModulos} modulos={modulos} fetchPagina={fetchPagina} onEdit={onEdit} setOnEdit={setOnEdit} />
            </ModalContent>
          </ModalContainer>
        )}

        {isModalOpenUsuario && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <ButtonClose onClick={() => {
                  modalUsuarios();

                }}>
                  {isModalOpenUsuario ? <IoClose color={"red"} size={25} /> : <IoClose color={"red"} size={25} />}
                </ButtonClose>
              </ButtonContainer>
              <Usuarios urlApi={urlApi} onEdit={onEdit} usuarios={usuarios} />
            </ModalContent>
          </ModalContainer>
        )}
      </Div>
      <Container>
        <Filtro>
          <Grid setOnEdit={setOnEdit} urlApi={urlApi} paginas={paginas} fetchPagina={fetchPagina} modalNovoModulo={modalNovoModulo} modalNovaPagina={modalNovaPagina} modalUsuarios={modalUsuarios} />
        </Filtro>

      </Container>


      <ToastContainer autoClose={1500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
      <GlobalStyle />
    </div>
  );
}

export default Modulos;
